/**
 * Simple handler to check whatever given value is a non-empty string
 * @param {Any} arg Value to check
 * @returns {Boolean} Result of check
 */
export default function isValidString(arg, s) {
  const isStr = typeof arg === 'string' && arg.length;
  return isStr && s ? arg.includes(s) : isStr;
}
